<template>
  <div class="Price" v-if="is_set">
      <strong :class="css_class" v-if="!is_phone">{{ $n(netto, 'currency') }} {{ $t('message.netto') }}</strong>
      <span class="discount" v-if="show_discount && !is_phone">({{ $t('message.discount', { discount: discount }) }}) / {{ $n(regular, 'currency') }} - {{ $t('message.net_detail') }}</span>
      <button class="btn btn-sm sale" v-if="product.data.price.sale" @click="open_sales()">{{ $t('message.sale') }}</button>
      <button class="btn btn-sm rise" v-if="product.data.price.rise" @click="open_rises()"><i class="fa fa-chevron-up"></i> {{ $t('message.rise') }}</button>
      <button class="btn btn-sm reduction" v-if="product.data.price.reduction" @click="open_reductions()"><i class="fa fa-chevron-down"></i> {{ $t('message.reduction') }}</button>
      <button class="btn btn-sm promotion" v-if="product.data.price.promotion" @click="open_promotions()">{{ $t('message.promotions') }}</button>
      <button class="btn btn-sm new" v-if="product.data.price.new" @click="open_news()">{{ $t('message.new') }}</button>
      <button class="btn btn-sm soon" v-if="product.data.price.soon" @click="open_soon()">{{ $t('message.soon') }}</button>
      <button class="btn btn-sm phone" @click="open_phone()" v-if="is_phone"><i class="fa fa-phone" style="transform: rotate(65deg);"></i> / <i class="fa">@</i></button>
  </div>
  <div v-else>

  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Price',
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    open_sales() {
      this.$modal.show('sales');
    },
    open_rises() {
      this.$modal.show('rises');
    },
    open_reductions() {
      this.$modal.show('reductions');
    },
    open_news() {
      this.$modal.show('news');
    },
    open_phone() {
      this.$modal.show('phone');
    },
    open_promotions() {
      this.$modal.show('promotions');
    },
    open_soon() {
      // this.$modal.show('promotions');
    }
  },
  computed: {
    is_set() {
      return this.netto; // && this.netto > 0;
    },
    is_phone() {
      return this.netto == 0;
    },
    netto() {
      let price = this.product.data.price.netto;
      if(!this.product.data.price.sale) {
        price = price - ((this.discount / 100) * price);
      }
      return parseFloat(price).toFixed(2);
    },
    regular() {
      return this.product.data.price.netto;
    },
    discount() {
      return this.$store.getters['pricelist/discount'];
    },
    css_class() {
      let class_name;
      if(this.discount !== 0) {
        class_name = ' with-discount ';
      }
      if(this.product.data.price.sale) {
        class_name = ' with-sale ';
      }
      return class_name;
    },
    show_discount() {
      return this.discount && !this.product.data.price.sale;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.rise {
  background: #dc3545;
}
.reduction {
  background: #59bf8d;
}
.new {
  background: #fcb400;
  color: #222;
}
.phone {
  background: #6868b1;
  color: #fff;
}
.promotion {
  background: #1c73e1;
  text-transform: uppercase;
  color: #fff;
}
.soon {
  background: #fffdfc;
  text-transform: uppercase;
  color: #f00;
}
.fa-minus {
  color: #ddd;
}
.no-price {
  font-size: .6em;
}
.with-sale {
  color: #04a9e6;
}
.with-discount {
  color: #dc3545;
}
.discount {
  font-size: .8em;
  display: block;
  @media(min-width: 768px) {
    display: inline;
    font-size: .6em;
  }
}
.btn-sm {
  font-size: .5em;
  font-weight: 7400;
}
.sale {
  background: #04a9e6;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Product/Price.vue